import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { OAuthApplication } from "../../auth";

interface IProps {
  orgIds?: string;
  content?: string;
  count?: number;
  applicationAuth?: boolean;
  active?: boolean;
  type?: string;
  name?: string;
}

export async function GetOrganizations({
  orgIds,
  count,
  content,
  applicationAuth,
  active,
  type,
  name,
}: IProps) {
  // Construir URL base
  let url = `${endpoints.ADMFHIR}/Organization`;

  // Adicionar ID específico se fornecido
  if (orgIds) {
    url = `${url}/${orgIds}`;
  } else {
    // Construir parâmetros de query apenas se não for busca por ID específico
    const queryParams: string[] = [];

    // Adicionar parâmetros válidos ao array
    if (content) queryParams.push(`_content=${encodeURIComponent(content)}`);
    if (count) queryParams.push(`_count=${count}`);
    if (active !== undefined) queryParams.push(`active=${active}`);
    if (type) queryParams.push(`type=${encodeURIComponent(type)}`);
    if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
    queryParams.push(`_sort=-_lastUpdated`);

    // Concatenar parâmetros com '&' se houver algum
    if (queryParams.length > 0) {
      url = `${url}?${queryParams.join("&")}`;
    }
  }

  const headers = {
    Accept: "*/*",
    Authorization: applicationAuth
      ? await OAuthApplication()
      : await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetOrganizations: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetOrganizations ", error);
      // toast.error(`GetOrganizations Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
